import { Component, Input, OnInit, inject } from '@angular/core';

import { LarmKriteriumDTO } from '../../../models/models';
import { Router } from '@angular/router';
import { AuthorizationService } from 'src/app/auth/services/authorization.service';
import { Role } from 'src/app/pages/anvandare/anvandare.models';
import { LarmTyp } from 'src/app/pages/larm-kriterium/larm-kriterium.component';

@Component({
    selector: 'app-larm-kriterium-details',
    templateUrl: './larm-kriterium-details.component.html',
    styleUrls: ['./larm-kriterium-details.component.scss'],
    standalone: false
})
export class LarmKriteriumDetailsComponent implements OnInit {
  private router = inject(Router);
  private authorizationService = inject(AuthorizationService);

  @Input() kriterium!: LarmKriteriumDTO;

  protected antibiotics: any[] = [];
  protected hasEditRights = false;
  protected larmTyp!:LarmTyp;

  ngOnInit(): void {
    this.hasEditRights = this.authorizationService.hasRole([Role.SuperanvandareIntern]);
      for (let value of Object.values(this.kriterium.antibiotics)) {
        this.antibiotics.push(value);
      }
      this.larmTyp = LarmTyp[this.kriterium.type as keyof typeof  LarmTyp];
  }

  protected editLarmkriterie(kriterium: LarmKriteriumDTO) {
    this.router.navigate(['nytt-larm-kriterium'], {queryParams: {copy: false}, state: kriterium });
  }

  protected copyLarmkriterie(kriterium: LarmKriteriumDTO) {
    this.router.navigate(['nytt-larm-kriterium'], { queryParams: {copy: true}, state: kriterium });
  }

}
